import React from 'react';
import { useHistory } from 'react-router-dom'

export default function NotFound() {
    const history = useHistory();
    function redirect(){
        history.push('/')

    }

  return <div>
      <h2>Sessão expirada porfavor faça o login novamente</h2>
      <button onClick={redirect}> Tentar Novamente </button>
  </div>;
}

